import React, { useState, useEffect } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import { addwebOrder } from "../../../redux/api/website/WebOrdersApi";
import { useDispatch } from "react-redux";
import { clearCartApi } from "../../../redux/api/website/Addtocartapi";
import { addOrdersAction } from "../../../redux/reduxSlice/admin/OrdersSlice";

const stripePromise = loadStripe(
  "pk_test_51RLtwyQnZiml7BywbuXGQDYbYjbLoDdaMu3k1856Njh4ylVw9gBVTJDo0yS6cXLh3oWtYIaFYVLr1AtkniK2h3B50069UVl0WC"
);

const StripePaymentForm = ({
  clientSecret,
  priceSummaryData,
  formData,
  cartItems,
  subtotal,
  shippingCost,
  total,
  onSuccess,
  handleSubmitShipmentOrder,
  handleSubmitCreateShipment,
  setShipmentOrderID,
  setCurrentStep,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!stripe || !elements) {
      setIsLoading(false);
      return;
    }

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        // this is safe to comment no worry this is use of additional confirmation 
        // confirmParams: {
        // receipt_email: formData.billingAddress.email,
        // },
        redirect: "if_required",
      });

      if (error) throw error;

      if (paymentIntent.status === "succeeded") {
        let shipemtOrderResponse;
        try {
          shipemtOrderResponse = await handleSubmitShipmentOrder();
          console.log(
            "shipemtOrderResponse in stripepayment",
            shipemtOrderResponse
          );
          setShipmentOrderID(
            shipemtOrderResponse?.data?.response?.order?.order_id
          );
        } catch (error) {
          console.log("shipemtOrderResponse error ", error);
        }

        let CreateShipmentResponse;
        try {
          CreateShipmentResponse = await handleSubmitCreateShipment();
          console.log(
            "CreateShipmentResponse in stripe",
            CreateShipmentResponse
          );
        } catch (error) {
          console.log("CreateShipmentResponse error in strip ", error);
        }

        const updatedItems =
          cartItems?.map((product) => ({
            productId: product.productId,
            productName: product.name,
            shippingCost: product.shippingCost || "",
            quantity: product.quantity || 1,
            unitPrice: product.price || 0,
            tax: product.tax || 0,
            totalPrice: (product.price || 0) * (product.quantity || 1),
            uniqueSerialNo: product.uniqueSerialNo,
            partKey: product.part_key,
            partType: product.part_type,
            image: product?.images?.image[0]?.id,
          })) || [];

        const updatedFormData = {
          ...formData,
          paymentMethod: "stripe",
          paymentId: paymentIntent.id,
          subtotalAmount: subtotal,
          shippingCost: shippingCost,
          totalAmount: total,
          items: updatedItems,
          order_id: shipemtOrderResponse?.data?.response?.order?.order_id,
          tracking_code:
            CreateShipmentResponse?.data?.response?.shipment?.tracking_code,

          ship_code: CreateShipmentResponse.data?.response?.shipment?.ship_code,
        };

        const res = await addwebOrder(updatedFormData);
        console.log("Order Response:", res);

        if (res.data.success) {
          const ROWID = res.data.orderId;
          dispatch(addOrdersAction({ ROWID, formData: updatedFormData }));
          toast.success("Order created successfully");
          dispatch(clearCartApi(localStorage.getItem("customerId")));
          onSuccess();
        }
      }
    } catch (error) {
      toast.error(error.message || "Payment failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-4 w-full">
      <div className="border-t pt-4">
        <div className="mb-4  rounded">
          <PaymentElement
            options={{
              wallets: {
                applePay: "auto",
                googlePay: "auto",
              },
              layout: {
                type: "accordion",
                defaultCollapsed: false,
              },
            }}
          />
        </div>
        <div className="flex w-100 justify-between">
          <button
            className="mt-4 bg-gray-200 font-semibold px-6 py-2 rounded-full "
            onClick={() => setCurrentStep(2)}
          >
            Back
          </button>
          <button
            type="submit"
            className="bg-blue-900 text-white px-6 py-2 rounded-full hover:bg-blue-800 mt-4"
            disabled={!stripe || isLoading}
          >
            {isLoading ? "Processing..." : "Pay Now"}
          </button>
        </div>
      </div>
    </form>
  );
};

// const StripePayment = (props) => (
//   <Elements
//     stripe={stripePromise}
//     options={{ clientSecret: props.clientSecret }}
//   >
//     {console.log("props--", ...props)}

//     <StripePaymentForm {...props} />
//   </Elements>
// );

// export default StripePayment;
const StripePayment = (props) => (
  <Elements
    stripe={stripePromise}
    options={{ clientSecret: props.clientSecret }}
  >
    {console.log("props--", props)}

    <StripePaymentForm {...props} />
  </Elements>
);

export default StripePayment;
